import {BaseLink, withRouter} from "react-router5";

export const TagItem = withRouter(({tag, router})=>{

    return <div><BaseLink routeName={"explore.theme"} routeParams={{id:tag.id}}  router={router} >
        <div className={'tagContainer'}>
            <span className={'tag'}>
	      {tag.item}
	      { tag.confidential && <div className="lock-icon-theme" /> }
	    </span>
        </div>
    </BaseLink>
    </div>
});
